import React from 'react';
import { cx } from '../lib/hooks';
import type { SceneToken } from '../scene/TokenObject';
type Props = {
  tokens: SceneToken[];
  promptLength: number;
  selectedIndex: number;
  onSelect: (index: number) => void;
  showTokens: boolean;
  wide: boolean;
};
export function SentenceBar({
  tokens,
  promptLength,
  selectedIndex,
  onSelect,
  showTokens,
  wide
}: Props) {
  const newest = tokens.length - 1;
  return <div className={cx('pointer-events-none absolute z-20 flex justify-center', wide ? 'left-[260px] right-[260px] top-5' : 'left-3 right-3 top-[52px]')} data-id="element-220" data-mp="1816n7m2f5opi">
      <div className="pointer-events-auto max-w-full rounded-2xl border border-white/[0.08] bg-white/[0.04] px-4 py-2 backdrop-blur-[16px]" data-id="element-221" data-mp="1hzcp43o86uud">
        <div className="flex flex-wrap items-center font-mono text-[15px] leading-7" data-id="element-222" data-mp="1d1b6fjupoxjf">
          {tokens.map((t, i) => <button key={t.key} type="button" onClick={() => onSelect(i)} className={cx('relative whitespace-pre rounded-[4px] transition-colors hover:text-white', i < promptLength ? 'text-[#C9CCD8]' : 'text-[#EDEEF2]', i === newest && i >= promptLength && 'animate-[newToken_1.8s_ease-out_both]')} data-id="element-223" data-mp="2oedn0ewt9n3l" data-mpi={i}>
              {t.text}
              <span className={cx('absolute inset-x-[1px] -bottom-0.5 h-[2px] rounded-full transition-opacity duration-500', !showTokens ? 'opacity-0' : i === selectedIndex ? 'opacity-100' : 'opacity-45')} style={{
            backgroundColor: t.color
          }} data-id="element-224" data-mp="2uheg8hp3fkad" />
            </button>)}
          <span className="ml-0.5 inline-block h-[18px] w-[8px] animate-[blink_1.1s_steps(1)_infinite] rounded-[1px] bg-[#EDEEF2]/80" data-id="element-225" data-mp="2bk3pxmlfw172" />
        </div>
      </div>
    </div>;
}